<template>
  <div>
    <b-button @click="modalShow = !modalShow">
      Open Modal
    </b-button>
    <b-modal v-model="modalShow">
      Hello From Modal!
    </b-modal>
  </div>
</template>
<style></style>
<script>
export default {
  name: 'Modal',
  data: () => ({
    modalShow: false,
  }),
};
</script>
